import { render, staticRenderFns } from "./PackagePDFSection.vue?vue&type=template&id=373ff05c&scoped=true&"
import script from "./PackagePDFSection.vue?vue&type=script&lang=js&"
export * from "./PackagePDFSection.vue?vue&type=script&lang=js&"
import style0 from "./PackagePDFSection.vue?vue&type=style&index=0&id=373ff05c&prod&lang=sass&"
import style1 from "./PackagePDFSection.vue?vue&type=style&index=1&id=373ff05c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373ff05c",
  null
  
)

export default component.exports